export function getAlternativeTetrisCandidates(candidates = [], representative = null) {
  const representativeId = String(representative?.id || '').trim();
  if (!representativeId) return [...candidates];
  return candidates.filter((candidate) => String(candidate?.id || '').trim() !== representativeId);
}
